import Lib from '../../../commons/lib';

export default class Service {
  static bufeUrl = window.location.origin + '/api/bufe/';

  // NTAK NAPLO START

  static initNaplo(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'ntak/naplo/init',
      args: { requestType: 'ntak-naplo-init' },
    }], fnDone);
  }

  static listNaplo(filterObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bufeUrl + 'ntak/naplo/list',
      args: { requestType: 'ntak-naplo-list' },
      data: filterObject
    }], fnDone);
  }

  static listNaploTetel(naploId, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'ntak/naplo/tetel/list',
      args: { requestType: 'ntak-naplo-tetel-list' },
      params: { id: naploId }
    }], fnDone);
  }

  static initForm(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'ntak/naplo/init',
      args: { requestType: 'ntak-naplo-init' },
    }], fnDone);
  }

  static resendNaplo(indoklas, ids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.bufeUrl + 'ntak/naplo/resend',
      args: { requestType: 'ntak-naplo-resend' },
      params: { indoklas: indoklas },
      data: ids
    }], fnDone);
  }

  static sztornoNaploTetel(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.bufeUrl + 'ntak/rms/sztorno',
      args: { requestType: 'ntak-rms-sztorno' },
      params: { id: id },
    }], fnDone);
  }

  // NTAK NAPLO END
}
